import { error, success } from "App/popupMessage";
import signalR from "Common/signalR";
import compact from "lodash/compact";
import difference from "lodash/difference";
import isEqual from "lodash/isEqual";
import keys from "lodash/keys";
import map from "lodash/map";
import locale from "./actionCreators.locale";
import actionTypes from "./actionTypes";
import api from "./api";
import { getInProgress, getOutdated, getSourceData, getSourceDataIgnoreOutdated, getUsedByUI } from "./selectors";
import { saveFile } from "Common/fileUtils/fileSave";
export default {
    download: () => ({
        type: actionTypes.DOWNLOAD_ONTOLOGICAL_MODEL,
        payload: {
            promise: () => api.downloadOntologicalModel().then(response => {
                const { isSuccess, errorMessage } = saveFile({
                    fileName: locale.ONTOLOGICAL_MODEL,
                    fileExtension: "xml",
                    file: response.data
                });
                if (isSuccess) {
                    return response;
                }
                return Promise.reject(new Error(errorMessage));
            })
        },
        completed: (dispatch) => {
            dispatch(success(locale.ONTOLOGICAL_MODEL_DOWNLOAD_SUCCESS));
        },
        rejected: (dispatch, { payload }) => {
            dispatch(error(locale.ONTOLOGICAL_MODEL_DOWNLOAD_FAILED(payload.message)));
        }
    }),
    upload: (file) => ({
        type: actionTypes.UPLOAD_ONTOLOGICAL_MODEL,
        payload: {
            promise: () => api.uploadOntologicalModel(file)
        },
        completed: (dispatch) => {
            dispatch(success(locale.UPLOAD_SUCCESS));
            dispatch({
                type: actionTypes.GET_ONTOLOGICAL_MODEL,
                payload: {
                    promise: () => api.getOntologicalModel()
                }
            });
        },
        rejected: (dispatch) => {
            dispatch(error(locale.UPLOAD_FAILED));
        }
    }),
    setOutdated: () => ({
        type: actionTypes.SET_OUTDATED
    }),
    getOntologicalModel: (skipIfInProgress = true, skipIfNoData = false) => (dispatch, getState) => {
        const state = getState();
        if (skipIfInProgress && getInProgress(state))
            return dispatch({
                type: actionTypes.SET_USED_BY_UI
            });
        if ((skipIfNoData && !getUsedByUI(state)) ||
            (getSourceDataIgnoreOutdated(state) && !getOutdated(state)))
            return undefined;
        return dispatch({
            type: actionTypes.GET_ONTOLOGICAL_MODEL,
            payload: {
                promise: () => api.getOntologicalModel()
            }
        });
    },
    saveOntologicalModel: (documentObjects, completed) => (dispatch, getState) => {
        const prevData = getSourceData(getState());
        if (!prevData)
            return undefined;
        const newSourceDataDocumentObjectsIds = map(documentObjects, "Id");
        const deletedDocumentObjectIds = difference(keys(prevData.DocumentObjects), newSourceDataDocumentObjectsIds);
        const newOrUpdatedDocumentObjects = compact(map(documentObjects, item => {
            const prev = prevData.DocumentObjects[item.Id];
            if (!prev)
                return item;
            if (isEqual(prev, item))
                return undefined;
            return item;
        }));
        if (!deletedDocumentObjectIds.length && !newOrUpdatedDocumentObjects.length)
            return dispatch({
                type: actionTypes.SET_HAS_CHANGES,
                hasChanges: false
            });
        return dispatch({
            type: actionTypes.SAVE_ONTOLOGICAL_MODEL,
            payload: {
                promise: () => {
                    var _a;
                    return api.saveOntologicalModel({
                        DeletedDocumentObjectIds: deletedDocumentObjectIds,
                        DocumentObjects: newOrUpdatedDocumentObjects,
                        SignalRConnectionId: (_a = signalR.connection) === null || _a === void 0 ? void 0 : _a.connectionId
                    });
                }
            },
            completed: (disp) => {
                disp(success(locale.SAVED_SUCCESSFULLY));
                completed && completed();
            },
            rejectedMessage: locale.SAVED_FAILED
        });
    },
    reloadOntology: (completed) => ({
        type: actionTypes.RELOAD_ONTOLOGY,
        payload: {
            promise: () => { var _a; return api.reloadOntology((_a = signalR.connection) === null || _a === void 0 ? void 0 : _a.connectionId); }
        },
        completed: (dispatch) => {
            dispatch(success(locale.RELOAD__SUCCESS));
            completed && completed();
        },
        rejectedMessage: locale.RELOAD__FAILED
    }),
    exportOntology: (completed) => ({
        type: actionTypes.RELOAD_ONTOLOGY,
        payload: {
            promise: () => api.exportOntology()
        },
        completed: (dispatch) => {
            dispatch(success(locale.EXPORT__SUCCESS));
            completed && completed();
        },
        rejectedMessage: locale.EXPORT__FAILED
    }),
    setOntologicalModel: (data, updateSourceData) => ({
        type: actionTypes.SET_ONTOLOGICAL_MODEL,
        updateSourceData,
        data
    }),
    setDetailedPanelOpen: (detailedPanelOpen) => ({
        type: actionTypes.SET_DETAILED_PANEL_OPEN,
        detailedPanelOpen
    }),
    setHasChanges: (hasChanges) => ({
        type: actionTypes.SET_HAS_CHANGES,
        hasChanges
    }),
    setLayoutAlgorithm: (layoutAlgorithm) => ({
        type: actionTypes.SET_LAYOUT_ALGORITHM,
        layoutAlgorithm
    }),
    setShowNames: (showNames) => ({
        type: actionTypes.SET_SHOW_NAMES,
        showNames
    }),
    setFilterText: (filterText) => ({
        type: actionTypes.SET_FILTER_TEXT,
        filterText
    }),
    setPanelWidth: (width) => ({
        type: actionTypes.SET_PANEL_WIDTH,
        width
    })
};
